import React from "react";

const SegmentedBoolean = ({
  label,
  id,
  value = false,
  onChange,
  darkMode = false,
  className = "",
  trueLabel = "Yes",
  falseLabel = "No",
}) => {
  const options = [
    { label: falseLabel, value: false },
    { label: trueLabel, value: true },
  ];
  const selectedIndex = value ? 1 : 0;

  return (
    (
      <div className="relative w-full">
        {label && (
          <label
            htmlFor={id}
            className={`absolute -top-2 left-2 inline-block rounded-sm px-1 text-xs font-medium z-20
              ${darkMode ? "bg-darkMainColor text-white" : "bg-white text-gray-900"}
            `}
          >
            {label}
          </label>
        )}
        <div
          id={id}
          className={`relative flex items-center rounded-md p-1 w-full
            ${darkMode ? "bg-white/5" : "bg-black/5"}
            ${className}
          `}
        >
          {/* Sliding Background */}
          <div
            className={`absolute top-1 bottom-1 left-1 rounded-md shadow transition-all duration-300
              ${darkMode ? "bg-white/10" : "bg-white"}
            `}
            style={{
              width: `calc((100% - 8px) / 2)`,
              transform: `translateX(${selectedIndex * 100}%)`,
            }}
          />

          {/* Options */}
          {options.map((option) => (
            <button
              type="button"
              key={option.value}
              onClick={() => onChange && onChange(option.value)}
              className={`relative z-10 flex items-center justify-center gap-2 px-4 py-1 text-sm font-medium transition-colors duration-200 w-full ${
                value === option.value
                  ? option.color ? `${option.color}` : (darkMode ? "text-white" : "text-black")
                  : (darkMode ? "text-gray-500" : "text-gray-500")
              }`}
            >
              {option.icon && <span>{option.icon}</span>}
              {option.label}
            </button>
          ))}
        </div>
      </div>
    )
  );
};

export default SegmentedBoolean;
